export default __webpack_public_path__ + "static/media/rarity-btn-unique.f421ad71.svg";